import { Check, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/hooks/use-i18n';

export function LanguageSwitcher() {
  const { currentLanguage, languages, changeLanguage } = useI18n();

  const handleLanguageChange = (language: string) => {
    changeLanguage(language);
  };

  const getCurrentLanguageLabel = () => {
    return languages[currentLanguage as keyof typeof languages] || languages.es;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' size='sm' className='h-8 px-2'>
          <span className='text-xs'>{getCurrentLanguageLabel()}</span>
          <ChevronDown className='ml-1 h-3 w-3' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='w-36'>
        {Object.entries(languages).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => handleLanguageChange(code)}
            className='flex items-center justify-between cursor-pointer'
          >
            <span className='text-sm'>{label}</span>
            {currentLanguage === code && (
              <Check className='h-4 w-4 text-primary' />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
